// Importaciones de paquetes
import React, { useEffect, useMemo, useRef, useState } from "react";
import { MRT_ColumnDef } from "material-react-table";
import NOTIFICATION_SYSTEM from "../../main_components/alerts/notification_sistem";
import dayjs from 'dayjs';
// Importaciones de componentes
import { refresh_token } from "../../main_components/tokens/tokenrefreshNewMethod";
import { UPDATE_NULL_IDENTIFIERS } from "../../main_components/methods_v2/auxiliary_functions_new_method";
import { PURCHASE_ORDERS_INTERFACE } from "./interface/interface"
import MATERIAL_TABLE_CONTAINER from "../../main_components/material_table/table_container";
import GENERAL_FORM_PUSH_ORDERS from "../../main_components/material_table/general_form_pushorders";
import SEARCH_FILTERS from "./tools/search_filters";
import {
  updated_form_data,
  validate_data,
  validate_data_email,
  processed_format,
} from "./tools/auxiliar_funtions";


import { create_object } from "./tools/auxiliar_funtions";
//IMG / ICONS

import CREATE from "../../imgComponents/create.png";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TableChartIcon from "@mui/icons-material/TableChart";
import FindInPageIcon from '@mui/icons-material/FindInPage';
import AttachEmailOutlinedIcon from '@mui/icons-material/AttachEmailOutlined';
import { inf_partner, inf_details, inf_system_commentary, inf_email } from "./tools/inf_data";
import { inf_order_update, inf_order_update_concept } from "./tools/inf_data_update";
import { purchase_order_details_get, purchase_order_post, purchase_order_put, supplier_invoice_details_get, relationships_purchase_order_post } from "../../services/expenses/purchase_orders";
import { paginatedApiCall } from "../../main_components/pagination/paginated_api_call";
import { supplier_get } from "../../services/expenses/expense";
import { company_address_get } from "../../services/configuration/company";
import { purchase_order_code_get, purchase_order_delete, purchase_order_notifications_post } from "../../services/expenses/purchase_orders";
import { date_current, previous_date } from "../../main_components/date/date";

import { showAlert } from "../../main_components/alerts/alert_response.jsx";
export interface FormData {
  id: number | string;
  username: string;
  fullusername: string;
  phone: string;
  email: string;
  job: string;
}

type Address = {
  street: string | null;
  outdoor_number: string | null;
  inside_number: string | null;
  neighborhood: string | null;
  state: string | null;
  zip_code: string | null;
  address_type: string | null;
  country: string | null;
  city: string | null;
  town: string | null;
  reference: string | null;
  subsidiary: string | null;
};


interface Detail {
  id: string;
  description: string;
  product: string;
  price: number;
  quantity: number;
  clave_unidad: string;
  code: string;
  clave_prod_serv: string;
  total: number;
}


interface PurchaseOrder {
  id: string | number;
  system_commentary: string | number;
  date_register: string;
  date_received_document: string;
  order_number: string | null;
  status_code: string | null;
  partner_email: string,
  payment_method: string;
  form_of_payment: string;
  form_of_payment_code: string | null;
  id_business_partner_fk: number | null;
  supplier_rfc: string | null;
  supplier_name: string | null;
  currency: string;
  exchange: number;
  total: number;
  note: string | null;
  business_partner: string | null;
  details: Detail[];
  relationships: any;
  street: string | null;
  outdoor_number: string | null;
  inside_number: string | null;
  neighborhood: string | null;
  state: string | null;
  zip_code: string | null;
  address_type: string | null;
  country: string | null;
  city: string | null;
  town: string | null;
  reference: string | null;
  subsidiary: string | null;
}

const PURCHASE_ORDERS: React.FC = () => {
  const [data, setData] = useState<PURCHASE_ORDERS_INTERFACE[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [modalT, setmodalT] = useState<boolean>(false);
  const [loadingSkeleton, setLoadingSkeleton] = useState<boolean>(false);
  const [open_form, setopen_form] = useState(false);
  const [isNewEntry, setIsNewEntry] = useState(false);
  const [updateConcept, setUpdateConcept] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [formData, setformData] = useState<any>([]);
  const [methodDelete, setMethodDelete] = useState(false);
  const [identifier_data, setidentifier_data] = useState<any>(null);
  const [methodCustom, setMethodCustom] = useState<boolean>(true);
  const [sendEmail, setSendEmail] = useState<boolean>(true);
  const [viewSystemCommentary, setViewSystemCommentary] = useState<boolean>(true);
  const [valueSelect, setValueSelect] = useState<string>("TODOS");
  const [fi, setfi] = useState(dayjs(previous_date));
  const notificationSystemRef = useRef<any>(null);
  const [ff, setff] = useState(dayjs(date_current));


  const update_identifiers = [
    { username: "string" },
    { fullusername: "string" },
    { phone: "string" },
    { email: "string" },
    { paymethod: "string" },
    { job: "string" },
  ];

  const handleUpdatePurchaseOrders = async (originalObj: any, isNew: boolean, flagConcept = false) => {
    try {
      const isTokenValid = await verifyToken();
      if (!isTokenValid) {
        console.error("Token inválido o expirado. Deteniendo el proceso...");
        console.log("Actualizando token...");
        setTimeout(() => {
          handleUpdatePurchaseOrders(originalObj, isNew);
        }, 1000);
        return;
      }
      console.log(originalObj)
      if (flagConcept) {
        let details = [];
        const response = await purchase_order_details_get(originalObj?.id);
        details = response.data
        originalObj = {
          ...originalObj,
          details: {
            id_order: originalObj.id,
            details: details,
            update: true,
            customTableProps: { details: details, total: 0 }
          },
        };
        console.log(originalObj)
      }
      originalObj = {
        ...originalObj,
        date_received_document: dayjs(originalObj.date_received_document),
      };



      setformData(originalObj)
      setIsNewEntry(isNew);
      setLoadingSkeleton(false)
      setMethodDelete(false);
    } catch (error) {
      console.error("Error al manejar add_address_bp:", error);
      return null;
    }
  };


  // const handleViewDetailsPurchaseOrders = async (originalObj: any, isNew: boolean, flagConcept = false) => {
  //   try {
  //     const isTokenValid = await verifyToken();
  //     if (!isTokenValid) {
  //       console.error("Token inválido o expirado. Deteniendo el proceso...");
  //       console.log("Actualizando token...");
  //       setTimeout(() => {
  //         handleViewDetailsPurchaseOrders(originalObj, isNew);
  //       }, 1000);
  //       return;
  //     }

  //     console.log(originalObj);

  //     let details: any[] = [];
  //     let details_invoice: any[] = [];
  //     let error_details: any[] = [];

  //     let response: any = null;
  //     let response_invoice: any = null;
  //     let response_error_order: any = null;

  //     if (!originalObj?.relationships || originalObj.relationships.length === 0) {
  //       [response] = await Promise.all([
  //         purchase_order_details_get(originalObj?.id),
  //       ]);
  //     } else {
  //       [response, response_invoice, response_error_order] = await Promise.all([
  //         purchase_order_details_get(originalObj?.id),
  //         supplier_invoice_details_get(originalObj?.relationships[0]?.id_invoice_fk),
  //         relationships_purchase_order_post(originalObj.relationships[0]?.id_relationship_fk, { check_status_and_details: true }),
  //       ]);
  //     }

  //     details = response?.data || [];
  //     details_invoice = response_invoice?.data || [];
  //     error_details = response_error_order?.data || [];

  //     const viewObject = {
  //       details: {
  //         details: {
  //           proveedor: {
  //             supplier_name: originalObj.supplier_name,
  //             supplier_rfc: originalObj.supplier_rfc,
  //             order_number: originalObj.order_number,
  //             date_register: originalObj.date_register
  //           },
  //           concepts: details
  //         },
  //         status_code: originalObj.status_code,
  //         details_invoice: {
  //           relationships: originalObj.relationships,
  //           concepts: details_invoice
  //         },
  //         address: {
  //           outdoor_number: originalObj?.outdoor_number || null,
  //           inside_number: originalObj?.inside_number || null,
  //           neighborhood: originalObj?.neighborhood || null,
  //           state: originalObj?.state || null,
  //           zip_code: originalObj?.zip_code || null,
  //           street: originalObj?.street || null,
  //           country: originalObj?.country || null,
  //           city: originalObj?.city || null,
  //           town: originalObj?.town || null,
  //         },
  //         error_details: error_details,
  //         total: originalObj.total,
  //         id_order: originalObj.id,
  //       },
  //       system_commentary: originalObj.system_commentary
  //     };

  //     console.log(viewObject);
  //     setformData(viewObject);
  //     setIsNewEntry(isNew);
  //     setLoadingSkeleton(false);
  //     setMethodDelete(false);

  //   } catch (error) {
  //     console.error("Error al manejar add_address_bp:", error);
  //     return null;
  //   }
  // };

  const handleViewDetailsPurchaseOrders = async (originalObj: any, isNew: boolean, flagConcept = false) => {
    try {
      const isTokenValid = await verifyToken();
      if (!isTokenValid) {
        console.error("Token inválido o expirado. Deteniendo el proceso...");
        console.log("Actualizando token...");
        setTimeout(() => {
          handleViewDetailsPurchaseOrders(originalObj, isNew);
        }, 1000);
        return;
      }

      console.log(originalObj);

      let details: any[] = [];
      let details_invoice: any[] = [];
      let error_details: any[] = [];

      let response: any = null;
      let response_invoice: any = null;

      if (!originalObj?.relationships || originalObj.relationships.length === 0) {
        [response] = await Promise.all([
          purchase_order_details_get(originalObj?.id),
        ]);
      } else {
        // Realizamos las dos primeras llamadas sin problema
        [response, response_invoice] = await Promise.all([
          purchase_order_details_get(originalObj?.id),
          supplier_invoice_details_get(originalObj?.relationships[0]?.id_invoice_fk),
        ]);

        // Manejamos el error 409 de forma específica para relationships_purchase_order_post
        try {
          const response_error_order = await relationships_purchase_order_post(
            originalObj.relationships[0]?.id_relationship_fk,
            { check_status_and_details: true }
          );
          error_details = response_error_order?.data || [];
        } catch (err: any) {
          if (err?.response?.status === 409) {
            error_details = []
            console.warn("409 Conflict en relationships_purchase_order_post, pero se continúa normalmente");
          } else {
            throw err; // Si es otro error, lo lanzamos para que lo capture el catch general
          }
        }
      }

      details = response?.data || [];
      details_invoice = response_invoice?.data || [];

      // Construcción del objeto final para mostrar
      const viewObject = {
        details: {
          details: {
            proveedor: {
              supplier_name: originalObj.supplier_name,
              supplier_rfc: originalObj.supplier_rfc,
              order_number: originalObj.order_number,
              date_register: originalObj.date_register
            },
            concepts: details
          },
          status_code: originalObj.status_code,
          details_invoice: {
            relationships: originalObj.relationships,
            concepts: details_invoice
          },
          address: {
            outdoor_number: originalObj?.outdoor_number || null,
            inside_number: originalObj?.inside_number || null,
            neighborhood: originalObj?.neighborhood || null,
            state: originalObj?.state || null,
            zip_code: originalObj?.zip_code || null,
            street: originalObj?.street || null,
            country: originalObj?.country || null,
            city: originalObj?.city || null,
            town: originalObj?.town || null,
          },
          error_details: error_details,
          total: originalObj.total,
          id_order: originalObj.id,
        },
        system_commentary: originalObj.system_commentary
      };

      console.log(viewObject);
      setformData(viewObject);
      setIsNewEntry(isNew);
      setLoadingSkeleton(false);
      setMethodDelete(false);

    } catch (error) {
      console.error("Error al manejar handleViewDetailsPurchaseOrders:", error);
      return null;
    }
  };



  const handleAddPurchaseOrder = async (originalObj: any, isNew: boolean, copyOrder = false) => {
    console.log(originalObj);
    console.log(copyOrder);

    try {
      const isTokenValid = await verifyToken();
      if (!isTokenValid) {
        console.error("Token inválido o expirado. Deteniendo el proceso...");
        console.log("Actualizando token...");
        setTimeout(() => {
          handleAddPurchaseOrder(originalObj, isNew);
        }, 1000);
        return;
      }

      let details: any[] = [];
      let order_number_code: string;
      let suppliers: any[] = [];

      if (copyOrder) {
        // Ejecutar todo en paralelo
        const [suppliersRes, codeOrderRes, orderDetailsRes] = await Promise.all([
          fetchSupplier(),
          purchase_order_code_get(),
          purchase_order_details_get(originalObj?.id)
        ]);

        suppliers = suppliersRes;
        order_number_code = codeOrderRes.data.order_number;
        details = orderDetailsRes.data;
        originalObj = {
          ...originalObj,
          date_received_document: dayjs(originalObj.date_received_document),
        };
        console.log(originalObj)


      } else {
        // Ejecutar lo que se puede en paralelo
        const [suppliersRes, codeOrderRes] = await Promise.all([
          fetchSupplier(),
          purchase_order_code_get()
        ]);

        suppliers = suppliersRes;
        order_number_code = codeOrderRes.data.order_number;

        const address = await fetchAddress();
        if (address.length === 0) {
          console.error("No se pudo obtener address o partner");
          setLoadingSkeleton(true);
          return;
        }

        const fieldsToUpdate = [
          "street", "outdoor_number", "inside_number", "neighborhood", "state",
          "zip_code", "address_type", "country", "city", "town", "reference", "subsidiary",
        ];
        fieldsToUpdate.forEach((field) => {
          if (field in address) {
            originalObj[field] = address[field];
          }
        });
      }

      if (suppliers.length === 0) {
        console.error("No se pudo obtener suppliers");
        setLoadingSkeleton(true);
        return;
      }

      originalObj = {
        ...originalObj,
        business_partner_options: suppliers,
        order_number: order_number_code,
        details: {
          details: details,
          customTableProps: { details: details, total: 0 }
        }
      };

      console.log(originalObj);
      setformData(originalObj);
      setIsNewEntry(isNew);
      setLoadingSkeleton(false);
      setMethodDelete(false);
    } catch (error) {
      console.error("Error al manejar add_address_bp:", error);
      return null;
    }
  };


  const handleOpenForm = (new_value: any, isNew: boolean, flagConcept = false) => {
    setMethodCustom(false);
    if (isNew) {
      setLoadingSkeleton(true)
      setopen_form(true);
      setMethodDelete(false);
      handleAddPurchaseOrder(new_value, isNew);
    } else {

      setMethodCustom(flagConcept);
      setopen_form(true);
      setLoadingSkeleton(true)
      setMethodDelete(false);
      const transformedObject = transformObject(new_value);
      handleUpdatePurchaseOrders(transformedObject, isNew, flagConcept);
    }
  };




  const handleViewDetails = (new_value: any, isNew: boolean, flagConcept = false) => {
    setMethodCustom(false);
    setMethodCustom(flagConcept);
    setopen_form(true);
    setLoadingSkeleton(true)
    setMethodDelete(false);
    const transformedObject = transformObject(new_value);
    handleViewDetailsPurchaseOrders(transformedObject, isNew, flagConcept);
  }




  const handleSendEmail = (new_value: any, isNew: boolean) => {
    setMethodCustom(false);
    setMethodCustom(false);
    setopen_form(true);
    setLoadingSkeleton(true)
    setMethodDelete(false);
    const transformedObject = transformObject(new_value);

    let originalObj = {
      ...transformedObject,

      details: {
        details: transformedObject.partner_email,
      }
    };

    console.log(originalObj)

    setformData(originalObj)
    setIsNewEntry(isNew);
    setLoadingSkeleton(false)
  }





  const transformObject = (obj: any): PurchaseOrder => {
    return {
      id: obj?.id || null,
      system_commentary: obj?.system_commentary || null,
      date_register: obj?.date_register || null,
      date_received_document: obj?.date_received_document || null,
      order_number: obj?.order_number || null,
      status_code: obj?.status_code || null,
      payment_method: obj?.payment_method || "PUE",
      form_of_payment: obj?.form_of_payment || "EFECTIVO (01)",
      form_of_payment_code: obj?.form_of_payment_code || null,
      id_business_partner_fk: obj?.id_business_partner_fk || null,
      supplier_rfc: obj?.supplier_rfc || null,
      supplier_name: obj?.supplier_name || null,
      currency: obj?.currency || "MXN",
      exchange: obj?.exchange || 1,
      partner_email: obj?.partner_email,
      total: obj?.total || 0,
      note: obj?.note || null,
      business_partner: obj?.supplier_name || null,
      details: obj?.details ?? [], // Se deja vacío si no existen detalles
      relationships: obj?.relationships ?? null, // Se deja vacío si no existen detalles
      street: obj?.address?.street || null,
      outdoor_number: obj?.address?.outdoor_number || null,
      inside_number: obj?.address?.inside_number || null,
      neighborhood: obj?.address?.neighborhood || null,
      state: obj?.address?.state || null,
      zip_code: obj?.address?.zip_code || null,
      address_type: obj?.address?.address_type || null,
      country: obj?.address?.country || null,
      city: obj?.address?.city || null,
      town: obj?.address?.town || null,
      reference: obj?.address?.reference || null,
      subsidiary: obj?.address?.subsidiary || null

    };
  };

  const handleCopyPurchase = (new_value: any, isNew: boolean) => {
    setMethodCustom(false);
    setLoadingSkeleton(true)
    setMethodDelete(false);
    setopen_form(true);
    console.log("Valor original recibido:", new_value);
    const transformedObject = transformObject(new_value);
    console.log("Objeto transformado:", transformedObject);
    handleAddPurchaseOrder(transformedObject, true, true)
  };

  const handleClose = () => {
    if (viewDetails) {
      setopen_form(false);
      return
    }
    if (methodCustom) {
      handlePurchaseOrders()
    }
    setopen_form(false);
  };


  const handleCloseCustom = () => {
    handlePurchaseOrders()
    showAlert({
      msj: 'Estado de la orden, actualizado correctamente',
      status: true,
      notificationSystemRef: notificationSystemRef,
    });
    setopen_form(false);
  };


  const procesarObjeto = (obj: Record<string, any>) => {
    const {
      business_partner_options,
      details,
      street,
      outdoor_number,
      inside_number,
      neighborhood,
      state,
      zip_code,
      address_type,
      country,
      city,
      town,
      reference,
      subsidiary,
      paymethod,
      address,
      ...resto
    } = obj;

    const newAddress: Address = {
      street: street ?? null,
      outdoor_number: outdoor_number ?? null,
      inside_number: inside_number ?? null,
      neighborhood: neighborhood ?? null,
      state: state ?? null,
      zip_code: zip_code ?? null,
      address_type: address_type ?? null,
      country: country ?? null,
      city: city ?? null,
      town: town ?? null,
      reference: reference ?? null,
      subsidiary: subsidiary ?? null,
    };

    const newDetails = details?.customTableProps?.details ?? [];
    const total = details?.customTableProps?.total ?? 0;
    return {
      ...resto,
      details: newDetails,
      total,
      address: newAddress,
    };
  };

  const handleSaveData = async (
    finalObject: any,
    method: any,
    identifier_data: any
  ) => {
    console.log("Datos a procesar:", procesarObjeto(finalObject));
    console.log("True / Post, False / Put, Delete:", method);
    setmodalT(true);
    console.log(finalObject);

    try {
      switch (method) {
        case true:
          if (sendEmail) {
            if (finalObject.details.emails === "") {
              showAlert({
                msj: 'Favor de proporcionar correos validos',
                status: false,
                notificationSystemRef: notificationSystemRef,
              });

            } else {
              delete finalObject.details.details
              console.log(finalObject.details)
              await purchase_order_notifications_post(identifier_data, finalObject.details);
              showAlert({
                msj: 'Correo enviado correctamente',
                status: true,
                notificationSystemRef: notificationSystemRef,
              });
              handleClose();

            }

          } else {
            console.log("Creando objeto...");
            await purchase_order_post(procesarObjeto(finalObject));
            showAlert({
              msj: 'Orden de compra creada correctamente',
              status: true,
              notificationSystemRef: notificationSystemRef,
            });
            handlePurchaseOrders();
            handleClose();
            console.log("Objeto creado con éxito");
          }

          break;
        case false:
          if (updateConcept) {
          }
          else {
            var objectHeaders = procesarObjeto(finalObject)
            delete objectHeaders.total;
            await purchase_order_put(identifier_data, objectHeaders);
            showAlert({
              msj: 'Informacion actualizada correctamente',
              status: true,
              notificationSystemRef: notificationSystemRef,
            });
          }
          console.log("Objeto actualizado con éxito");
          handlePurchaseOrders();
          handleClose();
          break;
        case 'delete':
          console.log("Eliminando objeto...");
          await purchase_order_delete(identifier_data);
          console.log("Objeto actualizado con éxito");
          showAlert({
            msj: 'Orden de compra cancelada correctamente',
            status: true,
            notificationSystemRef: notificationSystemRef,
          });
          handlePurchaseOrders();
          handleClose();
          break;
        default:
          console.error("Método no reconocido");
      }
    } catch (error: any) {
      alert(error.response.data.errorMessage.es);
      console.error("Error al procesar los datos:", error);
    } finally {
      setmodalT(false);
      console.log("Operación finalizada.");
    }
  };

  const verifyToken = async (): Promise<boolean> => {
    try {
      return await refresh_token();
    } catch (error) {
      console.error("Error al verificar el token:", error);
      return false;
    }
  };


  const fetchPurchaseOrders = async (): Promise<PURCHASE_ORDERS_INTERFACE[]> => {
    try {
      const rawResponse = await paginatedApiCall(3, "purchase", { init_date: fi.format('YYYY-MM-DD'), end_date: ff.format('YYYY-MM-DD'), status: valueSelect === "TODOS" ? null : valueSelect });
      return UPDATE_NULL_IDENTIFIERS(
        rawResponse,
        update_identifiers
      ) as PURCHASE_ORDERS_INTERFACE[];
    } catch (error) {
      console.error("Error al obtener los datos del usuario:", error);
      return [];
    }
  };

  const fetchSupplier = async () => {
    try {
      const response = await supplier_get();
      return response.data;
    } catch (error) {
      console.error("Error al obtener el código del socio:", error);
      return [];
    }
  };


  const fetchAddress = async () => {
    try {
      const response = await company_address_get();
      return response.data;
    } catch (error) {
      console.error("Error al obtener el código del socio:", error);
      return [];
    }
  };


  const handlePurchaseOrders = async (event?: React.SyntheticEvent): Promise<void> => {
    event?.preventDefault();
    setIsLoading(true);
    setmodalT(true);
    setData([]);
    const isTokenValid = await verifyToken();
    if (!isTokenValid) {
      setIsLoading(true);
      setmodalT(true);
      console.error("Token inválido o expirado. Deteniendo el proceso...");
      console.log("Actualizando token...");
      setTimeout(() => {
        handlePurchaseOrders();
      }, 1000);
      return;
    }
    const data = await fetchPurchaseOrders();
    console.log(data)
    setData(data);
    setIsLoading(false);
    setmodalT(false);
  };

  useEffect(() => {
    handlePurchaseOrders();
  }, []);

  const columns: MRT_ColumnDef<PURCHASE_ORDERS_INTERFACE>[] = useMemo(
    () => [
      {
        id: "AC.",
        header: "AC.",
        size: 100,
        enableFilters: false,
        enableColumnFilters: false,
        enableColumnFiltering: false,
        enableEditing: false,
        enableColumnFilterModes: false,
        enableRowOrdering: false,
        enableGrouping: false,
        enableColumnDragging: false,
        enableColumnActions: false,
        accessorFn: (d) => {
          return (
            <div>
              <span
                title="Enviar Correo"
                onClick={() => {
                  console.log(d);
                  setUpdateConcept(false)
                  setMethodDelete(false);
                  setViewDetails(false)
                  handleSendEmail(d, true);
                  setSendEmail(true)
                  setidentifier_data(d.id);
                }}
              >
                <AttachEmailOutlinedIcon className="icons_general_delete"></AttachEmailOutlinedIcon>
              </span>

              <span
                title="Copiar Orden de Compra"
                onClick={() => {
                  console.log(d);
                  setUpdateConcept(false)
                  setMethodDelete(true);
                  setViewDetails(false)
                  setSendEmail(false)
                  handleCopyPurchase(d, false);
                }}
              >
                <ContentCopyIcon className="icons_general_color_d2922db5"></ContentCopyIcon>
              </span>
              <span
                title="Editar Orden de Compra"
                style={{ display: d?.status === "ABIERTO" ? "" : "none" }}
                onClick={() => {
                  console.log(d);
                  setUpdateConcept(false)
                  setMethodDelete(true);
                  handleOpenForm(d, false);
                  setViewDetails(false)
                  setidentifier_data(d.id);
                  setSendEmail(false)
                }}
              >
                <SaveAsIcon className="icons_general_save"></SaveAsIcon>
              </span>
              <span
                title="Editar Conceptos"
                style={{ display: d?.status === "ABIERTO" ? "" : "none" }}
                onClick={() => {
                  console.log(d);
                  setUpdateConcept(true)
                  setMethodDelete(true);
                  setViewDetails(false)
                  handleOpenForm(d, false, true);
                  setidentifier_data(d.id);
                  setSendEmail(false);
                }}
              >
                <TableChartIcon className="icons_general_save"></TableChartIcon>
              </span>
              <span
                title="Visualizar Detalles Orden de Compra"
                onClick={() => {
                  console.log(d);
                  setUpdateConcept(true)
                  setMethodDelete(true);
                  setViewDetails(true)
                  setSendEmail(false)
                  handleViewDetails(d, false, true);
                  setidentifier_data(d.id);
                }}
              >
                <FindInPageIcon className="icons_general_save"></FindInPageIcon>
              </span>

              <span
                style={{ display: d?.status === "ABIERTO" ? "" : "none" }}
                title="Cancelar Orden de Compra"
                onClick={() => {
                  setMethodCustom(false)
                  setUpdateConcept(false)
                  setMethodDelete(true);
                  setopen_form(true);
                  setSendEmail(false)
                  setViewDetails(false)
                  setidentifier_data(d?.id);
                }}
              >
                <DeleteIcon className="icons_general_delete"></DeleteIcon>
              </span>
            </div>
          );
        },
        muiTableHeaderCellProps: { align: "center" },
        muiTableBodyCellProps: { align: "center" },
      },
      {
        header: "No. Orden",
        accessorKey: "order_number",
        id: "order_number",
        size: 120,
      },
      {
        header: "Estado",
        accessorKey: "status",
        id: "status",
        size: 120,
        accessorFn: (row) => {
          const status = row.status;
          const getColor = (status: string) => {
            switch (status) {
              case "CANCELADO":
                return "bg-red-200 text-red-800";
              case "ABIERTO":
                return "bg-green-200 text-green-800";
              case "REVISION":
                return "bg-yellow-200 text-yellow-800";
              default:
                return "bg-gray-200 text-gray-800";
            }
          };

          return (
            <span
              className={`px-2 py-1 rounded-full text-sm font-semibold rdstatus ${getColor(
                status
              )}`}
            >
              {status}
            </span>
          );
        },
        muiTableBodyCellProps: { align: "justify" },
      },
      {
        header: "F. Registro",
        accessorKey: "date_document",
        id: "date_document",
        size: 140,
        accessorFn: (row: any) => {
          const date = new Date(row.date_document);
          return (
            <span className="text-gray-700">
              {date.toLocaleString("es-MX")}
            </span>
          );
        },
      },

      {
        header: "F. Recepción",
        accessorKey: "date_received_document",
        id: "date_received_document",
        size: 140,
        accessorFn: (row: any) => {
          const date = new Date(row.date_received_document);
          return (
            <span className="text-gray-700">
              {date.toLocaleString("es-MX")}
            </span>
          );
        },
      },
      {
        header: "Total",
        accessorKey: "total",
        size: 140,
        id: "total",
        accessorFn: (row: any) => {
          const total = parseFloat(row.total);
          const formatted = total.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
          return (
            <span className="text-green-600 font-bold">
              {formatted}
            </span>
          );
        },
        muiTableBodyCellProps: { align: "right" },
      },
      {
        header: "Forma de Pago",
        accessorKey: "form_of_payment",
        id: "form_of_payment",
        size: 160,
      },
      {
        header: "Método de Pago",
        accessorKey: "payment_method",
        id: "payment_method",
        muiTableBodyCellProps: { align: "center" },
        size: 160,

      },
      {
        header: "RFC Proveedor",
        accessorKey: "supplier_rfc",
        id: "supplier_rfc",
      },
      {
        header: "Proveedor",
        accessorKey: "supplier_name",
        id: "supplier_name",
      },
      {
        header: "Nota",
        accessorKey: "note",
        id: "note",
      },
      // {
      //   header: "N. Conceptos",
      //   accessorKey: "rows",
      //   id: "rows",
      // },
      {
        header: "Usuario Registro",
        accessorKey: "name_person_user",
        id: "name_person_user",
      },
    ],

    []
  );



  return (
    <div style={{ width: "100%", margin: "0 auto" }} className="new_table_v2">
      <NOTIFICATION_SYSTEM notificationSystemRef={notificationSystemRef}></NOTIFICATION_SYSTEM>

      <GENERAL_FORM_PUSH_ORDERS
        open={open_form}
        onClose={handleClose}
        data_form={sendEmail ? inf_email : viewDetails ? inf_details : updateConcept ? inf_order_update_concept : isNewEntry ? inf_partner : inf_order_update}
        onSave={handleSaveData}
        isNew={isNewEntry}
        title_create={sendEmail ? "NOTIFICAR POR CORREO" : "CREAR ORDEN DE COMPRA"}
        title_update={viewDetails ? "DETALLES" : "ACTUALIZAR ORDEN DE COMPRA"}
        validateField={sendEmail ? validate_data_email : validate_data}
        handleProcessedFormat={processed_format}
        FormData={FormData}
        original_data={formData}
        size={methodDelete ? "30%" : "75%"}
        methodDelete={methodDelete}
        methodCustom={methodCustom}
        message_delete="¿Esta seguro de cancelar esta orden de compra?"
        updatedFormData={updated_form_data}
        identifier_data={identifier_data}
        handleCloseCustom={handleCloseCustom}
        loadingSkeleton={loadingSkeleton}
        nameSuccessButton={sendEmail ? "ENVIAR" : null}
        // nameUpdateButton={"ENVIAR"}
        nameErrorButton={"CANCELAR"}
      />


      <MATERIAL_TABLE_CONTAINER
        columns={columns}
        data={data}
        breadcrumbs={[{ label: "ORDENES DE COMPRA", path: null }]}
        modalT={modalT}
        isLoading={isLoading}
        search_filters={<SEARCH_FILTERS setff={setff} setfi={setfi} fi={fi} ff={ff} setValueSelect={setValueSelect} valueSelect={valueSelect} handle_search={handlePurchaseOrders}></SEARCH_FILTERS>
        }
        component_header={
          <img
            style={{ cursor: "pointer" }}
            src={CREATE}
            onClick={() => {
              handleOpenForm(create_object, true); setViewDetails(false); setMethodCustom(false); setUpdateConcept(false); setSendEmail(false);
            }}
          ></img>
        }
        file_name_export="Ordenes de Compra"
        update_identifiers={update_identifiers}
      ></MATERIAL_TABLE_CONTAINER>
    </div>
  );
};

export default PURCHASE_ORDERS;
